<template>
  <div class="card add_settings">
    <div class="add_settings__header">
      <h4 class="title">
        {{ translate('settings.add_settings_filter') }}
      </h4>
    </div>

    <div class="add_settings__content">

      <div class="line">
        <p>
          {{ translate('settings.exclude_device_group') }}
        </p>
        <div class="filter checkbox">
          <label class="switch" @click.prevent="new_filter.exclude_groups = !new_filter.exclude_groups">
            <input type="checkbox" v-model="new_filter.exclude_groups">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="line" v-if="$store.getters.getPermissions.permissionGod === true">
        <p>
          {{ translate('settings.show_hidden_devices') }}
        </p>
        <div class="filter checkbox">
          <label class="switch" @click.prevent="new_filter.visible = !new_filter.visible">
            <input type="checkbox" v-model="new_filter.visible">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="line" v-if="$store.getters.getPermissions.permissionGod === true">
        <p>
          {{ translate('settings.show_single_simcard') }}
        </p>
        <div class="filter checkbox">
          <label class="switch" @click.prevent="new_filter.single_simcard = !new_filter.single_simcard">
            <input type="checkbox" v-model="new_filter.single_simcard">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="line" v-if="$store.getters.getPermissions.permissionGod === true">
          <p>
              {{ translate('device.not_version') }}
          </p>
          <div class="filter checkbox">
              <label class="switch" @click.prevent="new_filter.not_version = !new_filter.not_version">
                  <input type="checkbox" v-model="new_filter.not_version">
                  <span class="slider round"></span>
              </label>
          </div>
      </div>

      <div class="line" v-if="$store.getters.getPermissions.extendedSearchDeviceList === true">
        <p>
          {{ translate('device.apn') }}
        </p>
        <div class="filter checkbox">
          <label class="switch" @click.prevent="new_filter.apn = !new_filter.apn">
            <input type="checkbox" v-model="new_filter.apn">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

    </div>

    <div class="add_settings__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        @click.prevent="save"
      >
        {{ translate('save') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "ModalCustomDeviceList",
  props: ['filter'],

  data () {
    return {
      new_filter: {}
    }
  },
  created () {
    this.new_filter = Object.assign({}, this.filter)
    if (!this.new_filter.visible){
      this.$set(this.new_filter, 'visible', false)
    }
    if (!this.new_filter.single_simcard){
      this.$set(this.new_filter, 'single_simcard', false)
    }
    if (!this.new_filter.not_version){
      this.$set(this.new_filter, 'not_version', false)
    }
    if (!this.new_filter.exclude_groups){
      this.$set(this.new_filter, 'exclude_groups', false)
    }
    if (!this.new_filter.apn){
      this.$set(this.new_filter, 'apn', false)
    }
    // this.new_filter.visible = false
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      this.$emit('update', this.new_filter)
    },

  }
}

</script>

<style lang='scss' scoped>

  .add_settings{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;

      .line{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filter{
          min-width: auto;
        }
      }
    }

    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .add_settings{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
